import { Component, Input, OnInit, OnChanges, SimpleChanges } from "@angular/core";

@Component({
    selector: "app-layout-image-multiple",
    templateUrl: "./layout-image-multiple.component.html",
    styleUrls: ["./layout-image-multiple.component.scss"],
})
export class LayoutImageMultipleComponent implements OnInit, OnChanges {
    @Input() inputData: any;

    selectedImage: any = null;
    selectedIndex: number = 0;
    lightboxOpen: boolean = false;
    lightboxIndex: number = 0;

    constructor() {}

    ngOnInit() {
        this.initializeFeaturedImage();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['inputData']) {
            this.initializeFeaturedImage();
        }
    }

    initializeFeaturedImage() {
        if (this.inputData && this.inputData.ShowAttachments && this.inputData.ShowAttachments.length > 0) {
            this.selectedImage = this.inputData.ShowAttachments[0];
            this.selectedIndex = 0;
        } else {
            this.selectedImage = null;
            this.selectedIndex = 0;
        }
    }

    selectImage(item: any, index: number) {
        this.selectedImage = item;
        this.selectedIndex = index;
    }

    openLightbox(index: number) {
        this.lightboxIndex = index;
        this.lightboxOpen = true;
    }

    closeLightbox() {
        this.lightboxOpen = false;
    }

    nextLightbox(event?: Event) {
        if (event) event.stopPropagation();
        if (this.inputData?.ShowAttachments?.length) {
            this.lightboxIndex = (this.lightboxIndex + 1) % this.inputData.ShowAttachments.length;
        }
    }

    prevLightbox(event?: Event) {
        if (event) event.stopPropagation();
        if (this.inputData?.ShowAttachments?.length) {
            this.lightboxIndex = (this.lightboxIndex - 1 + this.inputData.ShowAttachments.length) % this.inputData.ShowAttachments.length;
        }
    }
}
